import { css } from 'styled-components';

import { SternumTheme } from '@sternum/theme';
import { SnackbarTheme } from '@sternum/ui';

import { Colors } from '../constants';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SBOMDarkSnackbarTheme(theme: SternumTheme): Partial<SnackbarTheme> {
  return {
    infoLeftBarColor: Colors.Transparent,
    infoIconColor: Colors.BlueMiddle,
    infoContentTextColor: Colors.DarkerText,
    infoTitleTextColor: Colors.DarkerText,
    infoTopBottomMargin: '12px',
    infoMaxWidth: '400px',
    infoBorderRadius: '4px',
    infoCloseIconContainerCss: css`
      & svg {
        transform: scale(0.7);
      }
    `,
    infoContainerCss: css`
      filter: drop-shadow(-12px 14px 34px rgba(84, 77, 104, 0.15));
    `,
    infoContentCss: css`
      gap: 2px;
    `,
    infoTitleCss: css`
      font-size: 12px;
      line-height: 18px;
    `,
    infoDescriptionCss: css`
      font-size: 12px;
      line-height: 18px;
    `,
    infoCloseIconContainerTopCss: css`
      margin-top: 8px;
      margin-right: 8px;
    `,
    infoCloseIconContainerCenteredCss: css`
      margin-right: 12px;
    `,
    infoIconContainerCss: css`
      align-items: center;
      margin-left: 12px;
      margin-right: 8px;

      & svg * {
        color: ${Colors.BlueDark};
      }
    `,

    successLeftBarColor: Colors.Transparent,
    successIconColor: Colors.GreenMiddle,
    successContentTextColor: Colors.DarkerText,
    successTitleTextColor: Colors.DarkerText,
    successTopBottomMargin: '12px',
    successMaxWidth: '400px',
    successBorderRadius: '4px',
    successCloseIconContainerCss: css`
      & svg {
        transform: scale(0.7);
      }
    `,
    successContainerCss: css`
      filter: drop-shadow(-12px 14px 34px rgba(84, 77, 104, 0.15));
    `,
    successContentCss: css`
      gap: 2px;
    `,
    successTitleCss: css`
      font-size: 12px;
      line-height: 18px;
    `,
    successDescriptionCss: css`
      font-size: 12px;
      line-height: 18px;
    `,
    successCloseIconContainerTopCss: css`
      margin-top: 8px;
      margin-right: 8px;
    `,
    successCloseIconContainerCenteredCss: css`
      margin-right: 12px;
    `,
    successIconContainerCss: css`
      align-items: center;
      margin-left: 12px;
      margin-right: 8px;

      & svg * {
        color: ${Colors.GreenMiddle};
      }
    `,

    warningLeftBarColor: Colors.Transparent,
    warningIconColor: Colors.OrangeMiddle,
    warningContentTextColor: Colors.DarkerText,
    warningTitleTextColor: Colors.DarkerText,
    warningTopBottomMargin: '12px',
    warningMaxWidth: '400px',
    warningBorderRadius: '4px',
    warningCloseIconContainerCss: css`
      & svg {
        transform: scale(0.7);
      }
    `,
    warningContainerCss: css`
      filter: drop-shadow(-12px 14px 34px rgba(84, 77, 104, 0.15));
    `,
    warningContentCss: css`
      gap: 2px;
    `,
    warningTitleCss: css`
      font-size: 12px;
      line-height: 18px;
    `,
    warningDescriptionCss: css`
      font-size: 12px;
      line-height: 18px;
    `,
    warningCloseIconContainerTopCss: css`
      margin-top: 8px;
      margin-right: 8px;
    `,
    warningCloseIconContainerCenteredCss: css`
      margin-right: 12px;
    `,
    warningIconContainerCss: css`
      align-items: center;
      margin-left: 12px;
      margin-right: 8px;

      & svg * {
        color: ${Colors.OrangeMiddle};
      }
    `,

    errorLeftBarColor: Colors.Transparent,
    errorIconColor: Colors.RedMiddle,
    errorContentTextColor: Colors.DarkerText,
    errorTitleTextColor: Colors.DarkerText,
    errorTopBottomMargin: '12px',
    errorMaxWidth: '400px',
    errorBorderRadius: '4px',
    errorCloseIconContainerCss: css`
      & svg {
        transform: scale(0.7);
      }
    `,
    errorContainerCss: css`
      filter: drop-shadow(-12px 14px 34px rgba(84, 77, 104, 0.15));
    `,
    errorContentCss: css`
      gap: 2px;
    `,
    errorTitleCss: css`
      font-size: 12px;
      line-height: 18px;
    `,
    errorDescriptionCss: css`
      font-size: 12px;
      line-height: 18px;
    `,
    errorCloseIconContainerTopCss: css`
      margin-top: 8px;
      margin-right: 8px;
    `,
    errorCloseIconContainerCenteredCss: css`
      margin-right: 12px;
    `,
    errorIconContainerCss: css`
      align-items: center;
      margin-left: 12px;
      margin-right: 8px;

      & svg * {
        color: ${Colors.RedMiddle};
      }
    `,
  };
}
